import React from 'react'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'

import ConstructionYear from '../common/ConstructionYear'
import Floor from '../common/Floor'
import Heat from '../common/Heat'
import HeatType from '../common/HeatType'
import EstateCondition from '../common/EstateCondition'
import Parking from '../common/Parking'
import ParkingSlots from '../common/ParkingSlots'
import Door from '../common/Door'
import FloorType from '../common/FloorType'
import Access from '../common/Access'
import Wc from '../common/Wc'
import Alarm from '../common/Alarm'
import Safe from '../common/Safe'
import Cctv from '../common/Cctv'
import Facade from '../common/Facade'
import Usage from '../common/Usage'
import ElectricityType from '../common/commercial/ElectricityType'
import Expandability from '../common/commercial/Expandability'
import ExpandabilitySqr from '../common/commercial/ExpandabilitySqr'
import Drains from '../common/land/Drains'
import FireSafety from '../common/commercial/FireSafety'
import Spaces from '../common/commercial/Spaces'
import Kitchen from '../common/commercial/Kitchen'
import InternalStairs from '../common/commercial/InternalStairs'
import Equipment from '../common/commercial/Equipment'
// import Equipped from '../common/commercial/Equipped'
import CargoRamp from '../common/commercial/CargoRamp'
import CargoElevator from '../common/commercial/CargoElevator'
import CargoElevatorLoad from '../common/commercial/CargoElevatorLoad'
// import CommercialPlot from '../common/commercial/CommercialPlot'
import MaxInnerHeight from '../common/commercial/MaxInnerHeight'
import Guarding from '../common/commercial/Guarding'
import IndustrialDoorWidth from '../common/commercial/IndustrialDoorWidth'
import IndustrialDoorHeight from '../common/commercial/IndustrialDoorHeight'
import Entrances from '../common/commercial/Entrances'
import Enclosure from '../common/land/Enclosure'
import Offices from '../common/commercial/Offices'
import DistancePort from '../common/land/DistancePort'
import DistanceRoadNetwork from '../common/land/DistanceRoadNetwork'
import { FormValues } from '..'
import PlotSqr from '../common/commercial/PlotSqr'
import DistanceAirport from '../common/land/DistanceAirport'
interface Props {
  control: Control<FormValues>
  trigger: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const CommercialIndustrialSpace = (props: Props) => {
  const { control, trigger, getValues, resetField, setValue } = props
  return (
    <>
      <ConstructionYear
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <EstateCondition
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Floor
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Usage
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Wc
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ElectricityType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Heat
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <HeatType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Spaces
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <PlotSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Expandability
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ExpandabilitySqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      {/* here missing construction type */}
      <Access
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoElevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoElevatorLoad
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FloorType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <MaxInnerHeight
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      {/* <Equipped
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      /> */}
      <Equipment
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Guarding
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Door
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Alarm
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Safe
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Cctv
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FireSafety
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Parking
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ParkingSlots
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <IndustrialDoorHeight
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <IndustrialDoorWidth
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Entrances
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CargoRamp
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <InternalStairs
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Enclosure
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Facade
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />

      <Offices
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Kitchen
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DistancePort
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DistanceRoadNetwork
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DistanceAirport
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Drains
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
    </>
  )
}

export default React.memo(CommercialIndustrialSpace)
